import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { motion } from 'framer-motion';
import './style.scss';
import { isMobile } from 'react-device-detect';

export default function CookieConsent() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = Cookies.get('cookie_consent');
        console.log(consent)
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const acceptCookies = () => {
        Cookies.set('cookie_consent', 'true', { expires: 365 });
        setIsVisible(false);
    };

    
    return (
        isVisible && (
            <motion.div
                className="cookie-consent"
                initial={{ opacity: 0, y: 40, x: !isMobile && '-50%' }}
                animate={{ opacity: 1, y: 0, x: !isMobile && '-50%' }}
                exit={{ opacity: 0, y: 40, x: !isMobile && '-50%' }}
                transition={{ duration: 0.4, ease: 'easeOut' }}
            >
                <p className='label-text'>
                    Мы используем cookie-файлы для улучшения работы сайта. Продолжая пользоваться сайтом, вы даёте согласие на использование файлов.
                </p>
                <div onClick={acceptCookies} className='cookie-consent__btn'>
                    <span className='label-text'>Хорошо</span>
                </div>
            </motion.div>
        )
    );
}
